import type { SpanId, TraceId } from "@/types/dispatch.types.tsx";

function randomHex(bytes: number): string {
  const buf = new Uint8Array(bytes);
  crypto.getRandomValues(buf);
  return Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
}

export const newTraceId = (): TraceId => randomHex(16);
export const newSpanId = (): SpanId => randomHex(8);
